(() => {
  'use strict';
  // Site-wide Shopify Inbox launcher rules (2026-10-04): compact icon on phones on every page,
  // hidden while the cart drawer is open, and layered below the Omnisend popup (z-index 200000).
  const light=document.createElement('style');
  light.textContent='shopify-chat{z-index:199999!important;--spqr-chat-bottom:calc(16px + env(safe-area-inset-bottom))}'+
    'body.template-product shopify-chat{--spqr-chat-bottom:calc(90px + env(safe-area-inset-bottom))}'+
    'html.js-drawer-open shopify-chat{display:none!important}';
  document.head.appendChild(light);
  // Same marker as spqr-product-page-ui.js, so only one launcher style is ever added.
  function chat(){
    const host=document.querySelector('shopify-chat'),shadow=host&&host.shadowRoot;
    if(!shadow||shadow.querySelector('[data-spqr-chat-style]'))return !!shadow;
    const style=document.createElement('style');style.dataset.spqrChatStyle='true';
    style.textContent='@media(max-width:768px){.activator-nudge{position:fixed!important;right:12px!important;bottom:var(--spqr-chat-bottom,16px)!important}.activator{width:44px!important;min-width:44px!important;height:44px!important;padding:10px!important;justify-content:center!important}.activator__label{display:none!important}}';
    shadow.appendChild(style);return true;
  }
  if(chat())return;
  const observer=new MutationObserver(()=>{if(chat())observer.disconnect();});
  observer.observe(document.documentElement,{childList:true,subtree:true});
  if(window.customElements)customElements.whenDefined('shopify-chat').then(chat);
})();
